import { ticketsFolder } from 'constants/Ticket';
import { useState } from 'react';
import { IEntryLine } from 'types/Draws';
import styles from './TicketEntry.module.css';

interface ITicketEntryProps {
  entry: IEntryLine;
  imageLoaded?: () => void;
}

const TicketEntry = ({ entry, imageLoaded }: ITicketEntryProps) => {
  const [ticketImageLoaded, setTicketImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setTicketImageLoaded(true);
    if (imageLoaded) {
      imageLoaded();
    }
  };

  return (
    <div className={styles.container}>
      <img
        src={`${ticketsFolder}/default-ticket-background.svg`}
        className={`${styles.ticketImage} ${ticketImageLoaded ? styles.ticketImageLoaded : ''}`}
        onLoad={handleImageLoad}
      />
      <div className={styles.numbersOverlay}>
        {entry.main.map((num, i) => (
          <span key={i} className={styles.number}>
            {num != null ? String(num).padStart(2, '0') : '--'}
          </span>
        ))}
        {entry.bonus.map((num, i) => (
          <span key={`b${i}`} className={`${styles.number} ${styles.bonus}`}>
            {num != null ? String(num).padStart(2, '0') : '--'}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TicketEntry;
